module.exports = __webpack_public_path__ + "img/ic_carteirinha.79742db2.svg";